import { useMemo, useState } from "react";

export default function ImageWithFallback({
  src,
  alt = "",
  className = "",
  fallbackSrc = "/fallback.jpg",
  loading = "lazy",
  referrerPolicy = "no-referrer",
}) {
  const initialSrc = useMemo(() => src || fallbackSrc, [src, fallbackSrc]);
  const [currentSrc, setCurrentSrc] = useState(initialSrc);
  const [loaded, setLoaded] = useState(false);

  return (
    <div className={`relative overflow-hidden ${className}`}>
      {!loaded && (
        <div className="absolute inset-0 bg-slate-100 animate-pulse" aria-hidden="true" />
      )}
      <img
        src={currentSrc}
        alt={alt}
        loading={loading}
        referrerPolicy={referrerPolicy}
        className="h-full w-full object-cover"
        onLoad={() => setLoaded(true)}
        onError={() => {
          if (currentSrc !== fallbackSrc) setCurrentSrc(fallbackSrc);
          setLoaded(true);
        }}
      />
    </div>
  );
}

